import { useCallback, useState } from "react";

import { getFirstDayOfYear, initialDate } from "@/service/ApplicationQueries";

interface DateFilters {
	StartDate: Date | null;
	EndDate: Date | null;
	SelectedUser: number;
}

const initialDataFilters: DateFilters = {
	StartDate: getFirstDayOfYear(),
	EndDate: initialDate(),
	SelectedUser: 0,
};

const useDateFilters = () => {
	const [selectedUser] = useState<number>(0);
	const [dataFilters, setDataFilters] =
		useState<DateFilters>(initialDataFilters);

	const updateDataFilters = useCallback(
		(startDate: Date | null, endDate: Date | null, selectedUser: number) => {
			setDataFilters({
				StartDate: startDate,
				EndDate: endDate,
				SelectedUser: selectedUser,
			});
		},
		[setDataFilters],
	);

	const resetDataFilters = useCallback(() => {
		setDataFilters({
			StartDate: getFirstDayOfYear(),
			EndDate: initialDate(),
			SelectedUser: 0,
		});
	}, []);

	return {
		dataFilters,
		selectedUser,
		updateDataFilters,
		resetDataFilters,
	};
};

export default useDateFilters;
